"use client"
import ErrorBox from "@/components/common/errors/errorBox";
import MultiError from "@/components/common/errors/multiError";
import SelectDiscipline from "@/components/common/inputs/selectDiscipline";
import Popup from "@/components/common/Popup";
import { apiGet, getOptCookie } from "@/lib/apiFetch";
import { ApiResponse } from "@/types/api";
import { EventInfo } from "@/types/event";
import { useTranslations } from "next-intl";
import { useEffect, useState, useTransition } from "react";
import EventCard from "./EventCard";
import EventFilter from "./EventFilters";

const perPage = 10;

export default function EventList(){

    const t = useTranslations("events");

    const [events, setEvents] = useState<ApiResponse<EventInfo[]> | undefined>(undefined)
    const [pending, startTransition] = useTransition()
    const [page, setPage] = useState(0)

    useEffect(() => {
        startTransition(async () => {
            setEvents(await getOptCookie(`/event/all/${page*perPage}/${perPage}`))
        })
    }, [])
    console.log(events)

   
    if(pending || !events) return (
        <div className="w-full p-4 flex flex-wrap gap-4">
        {([0,1,2]).map((i) => (
            
            <div key={i} className={"skeleton w-full h-20 delay-[" + (i*200) + "ms]"}>

            </div>
        ))}
        </div>
    )

     if(events.error || !events.data) {
        return(
            <div className="p-4">
                <MultiError code={events?.error ?? "serverError"} />
            </div>
        )
    }

    return(
        <div className="flex flex-wrap cols-1 md:cols-2 gap-2 md:gap-4">
            <EventFilter></EventFilter>
            {events?.data.map((event, i) => (
                <EventCard key={i} data={event} className="w-full shrink grow hover:scale-101" animationDelay={i*100} />
            ))}
        </div>
    )
}